import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { HiArrowLeft, HiSave } from 'react-icons/hi'
import { Button, Spinner } from 'flowbite-react'
import axios from 'axios'
import toast from 'react-hot-toast'
import { useAuth } from '../contexts/AuthContext'
import { API_BASE } from '../constants/inviteCode'
import AuthorityForm, { EMPTY_FORM, toPayload } from '../components/AuthorityForm'
import { toastApiError } from '../utils/apiError'

const CityAdminNew = () => {
  const navigate = useNavigate()
  const { token } = useAuth()
  const [formData, setFormData] = useState(EMPTY_FORM)
  const [saving, setSaving] = useState(false)

  const handleSave = async () => {
    if (!formData.name.trim()) {
      toast.error('City name is required')
      return
    }

    setSaving(true)
    try {
      const response = await axios.post(
        `${API_BASE}/authorities`,
        toPayload(formData),
        { headers: { Authorization: `Bearer ${token}` } }
      )
      toast.success('City created')
      navigate(`/city-admin/${response.data.id}`)
    } catch (error) {
      toastApiError(error, 'Failed to create city')
      setSaving(false)
    }
  }

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div>
            <Link
              to="/city-admin"
              className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 mb-3"
            >
              <HiArrowLeft className="h-4 w-4 mr-1" />
              Back to City Admin
            </Link>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              Add City
            </h1>
            <p className="text-gray-600 dark:text-gray-300 mt-1">
              Create a new city authority record.
            </p>
          </div>

          <Button onClick={handleSave} disabled={saving}>
            {saving ? (
              <Spinner size="sm" className="mr-2" />
            ) : (
              <HiSave className="h-4 w-4 mr-2" />
            )}
            Create City
          </Button>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <AuthorityForm
          isEditing
          formData={formData}
          onChange={setFormData}
          token={token}
          showSystemInfo={false}
        />
      </div>
    </div>
  )
}

export default CityAdminNew
